export const trimStr = str => str.replace(/\s/g, '')

export const formatPhoneNo = str => str.replace(/[^0-9]/g, "")  // cũng có thể đổi "/[^0-9]/g" -> "/\D/g"

export const checkValidPhoneNo = str =>
  /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(str)

// `(?:(?:(\s*\(?([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\)?\s*(?:[.-]\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})`